import { RootState } from './reducers';

export const getSession = (store: RootState) => store.session;
